import { PsHttpService } from '@patsnap/tahiti-core/common/ps-http'
import { injectable } from '@patsnap/tahiti-core/shared/inversify'
import type { MappingPccFragmentResult } from '@/components/ai/markdown/components/pcc-molecular/types'

export interface MappingApi {
    getMappingPccFragment(id: string): Promise<MappingPccFragmentResult>
}

export const MappingApi = Symbol('MappingApi')

@injectable()
export class MappingApiImpl extends PsHttpService implements MappingApi {
    get options() {
        return {
            baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/core-eurekals-api/eurekals_agent/1.0`,
        }
    }

    getMappingPccFragment(id: string): Promise<MappingPccFragmentResult> {
        return this.get({
            url: `/public/mapping/${encodeURIComponent(id)}`,
        }).then(res => res as unknown as MappingPccFragmentResult)
    }
}
